import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { clientsTabs } from '../../../routes/sales';

const SalesSideClients = () => {
  const tabs = clientsTabs();
  return <FingoPaper tabs={tabs} />;
};

export default SalesSideClients;
